import { Button, Form, Input, message, Spin } from "antd";
import React from "react";
import TextArea from "antd/es/input/TextArea";
import { useNavigate } from "react-router-dom";
import supportService from "../../services/support.service";

export default function BecomePartner() {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = (values) => {
    
    const partnerRequest = {
      name: values.name,
      surname: values.surname,
      email: values.email,
      phoneNumber: values.phone,
      playroomName: values.playroomName,
      address: values.address,
      companyId: values.companyId,
      city: values.city,
    };

    supportService.becomePartner(partnerRequest)
      .catch((err) => {
        console.log(err);
      });

    message.success("Uspješno ste aplicirali");
    navigate("/");
  };

  return (
    <div className="flex flex-col items-center justify-start h-full md:h-screen py-10 overflow-auto">
      <div className="w-full text-center py-6">
        <p className="text-3xl lg:text-6xl font-bold text-footerBlue">Želite postati partner?</p>
        <label
          className="block text-footerBlue font-semibold text-xl lg:py-4"
          htmlFor="expectedNumberOfAdults"
        >
          Nakon aplikacije, neko će vas uskoro kontaktirati
        </label>
      </div>

      <div className="w-full px-2 py-2 flex justify-center">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          className="w-full max-w-[900px]"
        >
          {/* Name and Surname */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
            <Form.Item
              name="name"
              rules={[{ required: true, message: "Unesite ime!" }]}
            >
              <Input
                className="h-12 text-lg font-semibold mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
                placeholder="Ime"
              />
            </Form.Item>

            <Form.Item
              name="surname"
              rules={[{ required: true, message: "Unesite prezime!" }]}
            >
              <Input
                className="h-12 text-lg font-semibold mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
                placeholder="Prezime"
              />
            </Form.Item>
          </div>

          {/* Email and Phone Number */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
            <Form.Item
              name="email"
              rules={[{ required: true, message: "Unesite email!", type: "email" }]}
            >
              <Input
                className="h-12 text-lg font-semibold mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
                placeholder="Email"
              />
            </Form.Item>

            <Form.Item
              name="phone"
              rules={[{ required: true, message: "Unesite broj telefona!" }]}
            >
              <Input
                className="h-12 text-lg font-semibold mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
                placeholder="Broj telefona"
              />
            </Form.Item>
          </div>

          {/* Playroom Name and Address */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
            <Form.Item
              name="playroomName"
              rules={[{ required: true, message: "Unesite ime igraonice!" }]}
            >
              <Input
                className="h-12 text-lg font-semibold mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
                placeholder="Ime igraonice"
              />
            </Form.Item>

            <Form.Item
              name="address"
              rules={[{ required: true, message: "Unesite adresu igraonice!" }]}
            >
              <Input
                className="h-12 text-lg font-semibold mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
                placeholder="Adresa igraonice"
              />
            </Form.Item>
          </div>

          {/* Company ID and City */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
            <Form.Item
              name="companyId"
              rules={[{ required: true, message: "Unesite ID kompanije!" }]}
            >
              <Input
                className="h-12 text-lg font-semibold mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
                placeholder="JIB"
              />
            </Form.Item>

            <Form.Item
              name="city"
              rules={[{ required: true, message: "Unesite grad!" }]}
            >
              <Input
                className="h-12 text-lg font-semibold mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
                placeholder="Grad"
              />
            </Form.Item>
          </div>



          {/* Submit Button */}
          <Form.Item>
            <Button
              type="submit"
              htmlType="submit"
              className="w-80 text-xl bg-buttonYellow text-footerBlue hover:bg-footerBlue hover:text-white font-bold py-6 rounded-[33px]"
            >
              POŠALJI APLIKACIJU
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}
